"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousStudentStateChanged = void 0;
const enumerations_1 = require("../enumerations");
class AnonymousStudentStateChanged {
    constructor(timestamp, oldState, newState) {
        this.timestamp = timestamp;
        this.oldState = oldState;
        this.newState = newState;
        this.eventType = AnonymousStudentStateChanged.EventType;
    }
}
exports.AnonymousStudentStateChanged = AnonymousStudentStateChanged;
AnonymousStudentStateChanged.EventType = enumerations_1.EventType.AnonymousStudentStateChanged;
